//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// The application header's element id, in a leaf module so that a consumer
// wanting to find the header in the document does not have to import the
// header itself: the panel host reads it, and the header is where a panel
// registrar will eventually live.
export const APP_HEADER_ID = 'app-header';
